<template>
  <div class="flex items-center gap-2">
    <p class="font-semibold max-md:font-sm">
      {{ label }}
      <span v-if="required" class="text-red-600">*</span>
    </p>

    <label :for="name" class="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        v-model="isChecked"
        :true-value="true"
        :false-value="false"
        :required="required ? true : undefined"
        :name="name"
        :id="name"
        @blur="handleBlur"
        class="sr-only peer"
      />

      <div
        class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
      ></div>
    </label>

    <p class="text-red-500" v-show="errorMessage && !meta.valid">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useField } from 'vee-validate';

export default {
  props: {
    type: {
      type: String,
      default: 'checkbox',
    },
    defaultSingleValue: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },

    // ✅ ВАЖНО: по умолчанию свитчи НЕ обязательные
    required: {
      type: Boolean,
      default: false,
    },

    property: {
      type: Number,
      default: undefined,
    },
  },

  setup(props) {
    const fieldName = ref(props.name);

    const { meta, errorMessage, validate, handleBlur, checked } = useField(fieldName, undefined, {
      type: 'checkbox',
      initialValue: props.defaultSingleValue,
    });

    const isChecked = ref(props.defaultSingleValue);

    watch(isChecked, newVal => {
      checked.value = newVal;
    });

    watch(
      () => props.defaultSingleValue,
      newVal => {
        isChecked.value = newVal;
        checked.value = newVal;
      },
    );

    return {
      errorMessage,
      validate,
      meta,
      handleBlur,
      isChecked,
    };
  },

  methods: {
    async validateField() {
      const validatedData = await this.validate();
      return {
        value: this.isChecked,
        valid: validatedData.valid,
        mode: 'single',
        property: this.property,
      };
    },
  },
};
</script>
